import React from "react";
import { Modal, ModalBody } from "reactstrap";

const PopupModal = ({ isOpen, message, backgroundColor, image, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop={false}
      style={{
        position: "fixed",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "auto",
        pointerEvents: "none",
      }}
      contentClassName="border-0 shadow-none bg-transparent"
    >
      <ModalBody
        style={{
          background: backgroundColor,
          color: "white",
          border: "2px solid white",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          textAlign: "center",
          padding: "15px",
          pointerEvents: "auto",
        }}
      >
        {image && (
          <img
            src={image}
            alt="Popup"
            style={{ width: "40px", marginBottom: "10px" }}
          />
        )}
        <div>{message}</div>
      </ModalBody>
    </Modal>
  );
};

export default PopupModal;
